import { User } from '@auth0/auth0-react';
import { Stack, Typography, Button } from '@mui/material';
import { useIntl, FormattedMessage } from 'react-intl';
import AppTheme from '@libs/mui/AppTheme';
import { getUserGreeting } from '@shared/entity';
import LogoutIcon from '@mui/icons-material/Logout';

type PageHeaderProps = {
  user: User | undefined;
  onLogout: () => void;
};

const PageHeader = ({ user, onLogout }: PageHeaderProps) => {
  const intl = useIntl();

  return (
    <Stack spacing={2} alignItems="center">
      <Typography variant="h4" fontWeight="bold" align="center">
        <FormattedMessage id="subscriptionPage.welcome" defaultMessage="Vítejte v aplikaci!" />
      </Typography>
      <Typography variant="h4" fontWeight="bold" color="primary">
        <FormattedMessage id="subscriptionPage.headline" defaultMessage="Kadeřník+" />
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        maxWidth={500}
        width="100%"
      >
        <FormattedMessage
          id="subscriptionPage.introduction"
          values={{
            b: chunks => <strong>{chunks}</strong>,
            strong: chunks => (
              <strong style={{ color: AppTheme.palette.primary.main }}>{chunks}</strong>
            ),
            userGreeting: user && `${getUserGreeting(user)} `,
          }}
        />
      </Typography>
      <Button variant="contained" onClick={onLogout} startIcon={<LogoutIcon />}>
        {intl.formatMessage({ id: 'logOut', defaultMessage: 'Odhlásit se' })}
      </Button>
    </Stack>
  );
};

export default PageHeader;
